import React, { useState } from 'react';
import PageWrapper from '@/components/ui/PageWrapper';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '@/common/SafeIcon';

const Booking = () => {
  const [formStep, setFormStep] = useState(1);

  const handleNext = (e) => {
    e.preventDefault();
    setFormStep(2);
  };

  return (
    <PageWrapper>
      <div className="py-24 bg-bgDark min-h-screen">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pt-10">
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-heading font-bold mb-4">Request an Appointment</h1>
            <p className="text-textMuted">Fill out the form below to request a booking. We will contact you to confirm the final details and pricing.</p>
          </div>

          <div className="bg-primary border border-white/10 rounded-2xl p-8 md:p-12 shadow-2xl">
            {/* Progress Bar */}
            <div className="flex items-center mb-10">
              <div className={`flex-1 h-1 rounded-l-full ${formStep >= 1 ? 'bg-accent' : 'bg-white/10'}`}></div>
              <div className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold ${formStep >= 1 ? 'bg-accent text-black' : 'bg-secondary text-textMuted border border-white/10'}`}>1</div>
              <div className={`flex-1 h-1 ${formStep >= 2 ? 'bg-accent' : 'bg-white/10'}`}></div>
              <div className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold ${formStep >= 2 ? 'bg-accent text-black' : 'bg-secondary text-textMuted border border-white/10'}`}>2</div>
              <div className={`flex-1 h-1 rounded-r-full ${formStep >= 3 ? 'bg-accent' : 'bg-white/10'}`}></div>
            </div>

            <form>
              {formStep === 1 && (
                <motion.div initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }} className="space-y-6">
                  <h3 className="text-2xl font-heading font-bold mb-6 border-b border-white/10 pb-4">Vehicle Information</h3>
                  
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label className="block text-sm font-medium text-textMuted mb-2">Vehicle Make</label>
                      <input type="text" className="input-field" placeholder="e.g. Porsche, BMW, Ford" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-textMuted mb-2">Vehicle Model</label>
                      <input type="text" className="input-field" placeholder="e.g. 911 GT3, M4, F-150" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-textMuted mb-2">Year</label>
                      <input type="text" className="input-field" placeholder="e.g. 2023" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-textMuted mb-2">Vehicle Type</label>
                      <select className="input-field appearance-none bg-secondary/50">
                        <option>Coupe / Sedan</option>
                        <option>Mid-size SUV / Crossover</option>
                        <option>Large SUV / Truck</option>
                        <option>Exotic / Supercar</option>
                      </select>
                    </div>
                  </div>

                  <div className="mt-8">
                    <label className="block text-sm font-medium text-textMuted mb-2">Service Requested</label>
                    <select className="input-field appearance-none bg-secondary/50">
                      <option>Premium Detail Package</option>
                      <option>Essential Detail Package</option>
                      <option>Ultimate Protection Package</option>
                      <option>Ceramic Coating Only</option>
                      <option>Paint Correction Only</option>
                      <option>Interior Deep Clean</option>
                    </select>
                  </div>

                  <div className="pt-6 flex justify-end">
                    <button onClick={handleNext} className="btn-primary">Next Step <SafeIcon icon={FiIcons.FiArrowRight} className="ml-2" /></button>
                  </div>
                </motion.div>
              )}

              {formStep === 2 && (
                <motion.div initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} className="space-y-6">
                  <h3 className="text-2xl font-heading font-bold mb-6 border-b border-white/10 pb-4">Contact & Scheduling</h3>
                  
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label className="block text-sm font-medium text-textMuted mb-2">Full Name</label>
                      <input type="text" className="input-field" placeholder="John Doe" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-textMuted mb-2">Phone Number</label>
                      <input type="tel" className="input-field" placeholder="(514) 555-0000" />
                    </div>
                    <div className="md:col-span-2">
                      <label className="block text-sm font-medium text-textMuted mb-2">Email Address</label>
                      <input type="email" className="input-field" placeholder="john@example.com" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-textMuted mb-2">Preferred Date</label>
                      <input type="date" className="input-field" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-textMuted mb-2">Drop-off Method</label>
                      <select className="input-field appearance-none bg-secondary/50">
                        <option>I will drop off at studio</option>
                        <option>Request Valet Pickup (Montreal area)</option>
                      </select>
                    </div>
                    <div className="md:col-span-2">
                      <label className="block text-sm font-medium text-textMuted mb-2">Special Requests / Vehicle Condition</label>
                      <textarea className="input-field h-32 resize-none" placeholder="Let us know about any specific stains, scratches, or areas of concern..."></textarea>
                    </div>
                  </div>

                  <div className="pt-6 flex justify-between">
                    <button type="button" onClick={() => setFormStep(1)} className="btn-outline border-white/20 text-white">Back</button>
                    <button type="button" onClick={() => {alert("Booking request submitted! (Demo only)"); setFormStep(1);}} className="btn-primary">This demo only</button>
                  </div>
                </motion.div>
              )}
            </form>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default Booking;